import { useRef } from 'react'

import { ProductReviewsContainer } from '../../../../../containers/ProductReviewsContainer'

export const ProductReviewsTableScrollOnPageChange = () => {
  const { results } = ProductReviewsContainer.useContainer()
  const scrollToElementRef = useRef<HTMLElement | null>(null)
  const currentPageNumber = results?.pagination?.pageNum
  const priorPageNumberRef = useRef(results?.pagination?.pageNum)

  // Why am I debouncing page changes? Well ask ProductReviewsContainer.useContainer(), because when I click page 4
  // while on page 3, it returns page 4, then page 3, then page 4 in rapid succession.
  const scrollingLockedRef = useRef(false)

  // results?.pagination?.pageNum has a pretty crap typing, there is no real reason why we wouldn't
  // know our page number instantly on page load, but it is typed as null|undefined|number. Because of
  // that, it is safest to not scroll until we have a change in number where the prior state itself was
  // also a valid number. And to be further safe, we can ignore new values from results?.pagination?.pageNum
  // that are not numbers, just incase it flops between null and a number or anything else crazy.
  if (typeof currentPageNumber === 'number' && priorPageNumberRef.current !== currentPageNumber) {
    if (
      typeof priorPageNumberRef.current === 'number' &&
      scrollToElementRef.current &&
      scrollingLockedRef.current === false
    ) {
      scrollingLockedRef.current = true
      const elementRect = scrollToElementRef.current.getBoundingClientRect()
      const elementTop = elementRect.top
      const viewportHeight = Math.min(
        document.documentElement.clientHeight ?? 0,
        window.innerHeight ?? 0
      )
      const scrollPosition = elementTop + window.scrollY - viewportHeight * 0.1
      window.scrollTo({
        top: scrollPosition,
        behavior: 'smooth',
      })
      window.setTimeout(() => {
        scrollingLockedRef.current = false
      }, 1000)
    }
    priorPageNumberRef.current = currentPageNumber
  }

  return <span ref={scrollToElementRef} aria-hidden='true' style={{ height: '0px' }}></span>
}
